export const MAPBOX_ACCESSTOKEN = 'pk.eyJ1IjoiaW1hamltYXJpIiwiYSI6ImNtcHl6enpjbzBjMWgycXM1ZHg1dHB3cDIifQ.sn0aGu67gRTOkSCjaCpNzg';

export const MAPBOX_STYLE_TILE = {
    ja: {
        default: `https://api.mapbox.com/styles/v1/imajimari/cmpakpe7c001b01rihuo01881/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
        dark: `https://api.mapbox.com/styles/v1/imajimari/cmq4hp0q9004v01rf44th5bq4/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
        satellite: `https://api.mapbox.com/styles/v1/imajimari/cmq4gz3tj001c01sl78r40bix/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
    },
    en: {
        default: `https://api.mapbox.com/styles/v1/imajimari/cmrnj14m3001o01rjf4ijb4ep/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
        dark: `https://api.mapbox.com/styles/v1/imajimari/cmuxqgm8b00hv01ss8b3r0q40/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
        satellite: `https://api.mapbox.com/styles/v1/imajimari/cmuxquyia000m01rehrype0p0/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_ACCESSTOKEN}`,
    },
};

export const MAPBOX_STYLE = {
    ja: {
        default: 'mapbox://styles/yk-gaia-vision/cl368zeyb000h15qn2vsxh3b9',
    },
    en: {
        default: 'mapbox://styles/mapbox/outdoors-v12',
        dark: 'mapbox://styles/imajimari/cmuxqgm8b00hv01ss8b3r0q40',
        satellite: 'mapbox://styles/imajimari/cmuxquyia000m01rehrype0p0',
    },
};
